// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home{margin-top:4rem}.home .landing-padding{margin-left:1rem;margin-right:1rem;margin-bottom:1rem}", ""]);
// Exports
module.exports = exports;
